import CycleMeasurementSymbol from '../../enums/cycle-measurement-symbol';
import TextAlignment from '../../enums/text-aligment.enum';
import { ICycleOptions } from './types';

export const DEFAULT_BLOCK_PARAMETERS = 'min-w-[58px]'

const getOptions = (measurement: keyof typeof CycleMeasurementSymbol): ICycleOptions => ({
  NAME: {
    NAME: 'Name',
    KEY: 'name',
    BLOCK_PARAMETERS: 'min-w-[180px] pl-2 align-start',
    ALIGNMENT: TextAlignment.Start,
  },
   OUTPUT: {
    NAME: 'O.E.',
    KEY: 'output_enabled',
    BLOCK_PARAMETERS: DEFAULT_BLOCK_PARAMETERS,
    ALIGNMENT: TextAlignment.Center,
  },
  P_LIM: {
    NAME: 'P-LIM',
    KEY: 'Pw',
    BLOCK_PARAMETERS: DEFAULT_BLOCK_PARAMETERS,
    ALIGNMENT: TextAlignment.Center,
  },
  TRIM: {
    NAME: 'TRIM',
    KEY: 'Tr',
    BLOCK_PARAMETERS: DEFAULT_BLOCK_PARAMETERS,
    ALIGNMENT: TextAlignment.Center,
  },
  DEGREES: {
    NAME: CycleMeasurementSymbol[measurement],
    KEY: 'degrees',
    BLOCK_PARAMETERS: DEFAULT_BLOCK_PARAMETERS,
    ALIGNMENT: TextAlignment.Center,
  },
  SP: {
    NAME: 'SP',
    KEY: 'sp',
    BLOCK_PARAMETERS: DEFAULT_BLOCK_PARAMETERS,
    ALIGNMENT: TextAlignment.Center,
  },
  DELTA_T: {
    NAME: 'Delta T',
    KEY: 'deltaT',
    BLOCK_PARAMETERS: DEFAULT_BLOCK_PARAMETERS,
    ALIGNMENT: TextAlignment.Center,
  },
  PRESENT: {
    NAME: '%P',
    KEY: 'present',
    BLOCK_PARAMETERS: DEFAULT_BLOCK_PARAMETERS,
    ALIGNMENT: TextAlignment.Center,
  },
  CURRENT: {
    NAME: 'Current',
    KEY: 'current',
    BLOCK_PARAMETERS: DEFAULT_BLOCK_PARAMETERS,
    ALIGNMENT: TextAlignment.Center,
  },
  STATE: {
    NAME: 'State',
    KEY: 'state',
    BLOCK_PARAMETERS: `${DEFAULT_BLOCK_PARAMETERS} pr-2`,
    ALIGNMENT: TextAlignment.Center,
  },
});

export const CYCLE_POSTWELD_OPTIONS: ICycleOptions = {
  STEP: {
    NAME: 'Step',
    KEY: 'current_step',
    BLOCK_PARAMETERS: DEFAULT_BLOCK_PARAMETERS,
    ALIGNMENT: TextAlignment.Center,
  },
  MINUTES: {
    NAME: 'Mins Left',
    KEY: 'mins_left',
    BLOCK_PARAMETERS: `${DEFAULT_BLOCK_PARAMETERS} pr-2`,
    ALIGNMENT: TextAlignment.Center,
  },
};

export default getOptions;
